export interface IconSettingsProps extends React.SVGProps<SVGSVGElement> {}

export const IconSettings = (props: IconSettingsProps) => {
    return (
        <svg id="icoReview" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
            <rect id="Rectangle_3767" data-name="Rectangle 3767" width="24" height="24" fill="none" stroke="none" />
            <g
                id="Ellipse_486"
                data-name="Ellipse 486"
                transform="translate(3.5 4)"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeWidth="inherit"
            >
                <circle cx="3.5" cy="3.5" r="3.5" stroke="none" />
                <circle cx="3.5" cy="3.5" r="2.75" fill="none" />
            </g>
            <g
                id="Ellipse_487"
                data-name="Ellipse 487"
                transform="translate(20.5 20) rotate(180)"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeWidth="inherit"
            >
                <circle cx="3.5" cy="3.5" r="3.5" stroke="none" />
                <circle cx="3.5" cy="3.5" r="2.75" fill="none" />
            </g>
            <path
                id="Path_6263"
                data-name="Path 6263"
                d="M30,350h7"
                transform="translate(41.5 366.5) rotate(180)"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeWidth="inherit"
            />
            <path
                id="Path_6264"
                data-name="Path 6264"
                d="M30,350h7"
                transform="translate(-17.498 -342.5)"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeWidth="inherit"
            />
        </svg>
    );
};
